import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiRequest } from "@/api/client";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";

/**
 * CompanyPicker — Picker delle aziende per le esportazioni.
 * Estratto da Exports.jsx (P2 refactoring) per ridurre la dimensione del file principale.
 */
export default function CompanyPicker() {
  const [companies, setCompanies] = useState([]);
  useEffect(() => { apiRequest("/companies").then(setCompanies); }, []);
  return (
    <div className="space-y-6" data-testid="exports-picker-page">
      <section className="rounded-lg border border-slate-200 bg-white p-6">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-900">Esportazioni DVR</p>
        <h2 className="mt-2 font-heading text-4xl font-bold text-slate-950">Seleziona azienda</h2>
        <p className="mt-2 text-slate-600">Genera PDF e DOCX del DVR e dei moduli collegati con intestazione, firme, registro revisioni e watermark.</p>
      </section>
      <Card className="shadow-none"><CardContent className="space-y-3 p-6">
        {companies.length === 0 && (
          <p className="rounded-md border border-dashed border-slate-300 p-6 text-sm text-slate-500" data-testid="exports-picker-empty">
            Nessuna azienda disponibile.
          </p>
        )}
        {companies.map((c) => (
          <Link
            key={c.id}
            to={`/aziende/${c.id}/esportazioni`}
            className="flex justify-between rounded-md border border-slate-200 p-4 transition hover:bg-slate-50"
            data-testid={`exports-company-${c.id}`}
          >
            <span className="font-semibold text-slate-950">{c.business_name}</span>
            <Badge className="bg-blue-50 text-blue-900">Apri</Badge>
          </Link>
        ))}
      </CardContent></Card>
    </div>
  );
}
